import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Navbar from "./main/components/main/Navbar";
import Main from "./main/components/main/Main";
import Login from "./main/components/main/Login";
import Register from "./main/components/main/Register";
import LoggedIn from "./main/components/other/logged_in/LoggedIn";
import ErrorPage from "./main/components/error/ErrorPage";

import ParticlesComponent from "./main/utils/components/ParticlesComponent";
import InformationAboutTeacherHub from "./main/components/main/mainPage/footer/InformationAboutTeacherHub";
import CommunityArticles from "./main/components/main/mainPage/footer/CommunityArticles";
import CommunityVideos from "./main/components/main/mainPage/footer/CommunityVideos";
import CooperateWithUs from "./main/components/main/mainPage/footer/CooperateWithUs";
import TermsAndConditions from "./main/components/main/mainPage/footer/TermsAndConditions";
import Contact from "./main/components/main/mainPage/footer/Contact";
import { TokenChecker } from "./main/utils/components/TokenChecker";
import PaypalAuth from "./main/components/other/paypal/PaypalAuth";
import ForgotPassword from "./main/components/main/ForgotPassword";
import ResetPassword from "./main/components/main/ResetPassword";
import FindTeacher from "./main/components/main/mainPage/FindTeacher";

function AppContent() {
    const location = useLocation();

    // Hide navbar only on /logged-in
    const hideNavbar = location.pathname === "/logged-in";

    return (
        <>
            <ParticlesComponent id="particles" />
            <TokenChecker />
            {!hideNavbar && <Navbar />}
            <PaypalAuth />

            <Routes>
                <Route path="/" element={<Main />} />
                <Route path="/login" element={<Login />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/find-teacher" element={<FindTeacher />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/register" element={<Register />} />
                <Route path="/logged-in" element={<LoggedIn />} />
                <Route path="/about-us" element={<InformationAboutTeacherHub />} />
                <Route path="/community-articles" element={<CommunityArticles />} />
                <Route path="/community-videos" element={<CommunityVideos />} />
                <Route path="/cooperate-with-us" element={<CooperateWithUs />} />
                <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
                <Route path="/contact-us" element={<Contact />} />
                <Route path="*" element={<ErrorPage />} />
            </Routes>
        </>
    );
}

export default function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AppContent />
            </BrowserRouter>
        </div>
    );
}